import React from 'react';

const OfflineIconSingle = (props) => {
  let { 
    height, 
    width, 
    iconColor,
  } = props;
  
  return (
    <svg xmlns="http://www.w3.org/2000/svg" 
      width={width ? width : '21px'} 
      height={height ? height : '16px'} 
      viewBox="0 0 21 16">
      <g fill="none" 
        fillRule="nonzero" 
        stroke={iconColor}
      >
        <path 
          strokeWidth="1.5" 
          d="M15.709 5.932c2.221.334 3.916 2.233 3.916 4.48 0 2.508-2.077 
          4.544-4.622 4.544h-9.13a4.658 4.658 0 0 1-2.271-.587c-1.439-.801-2.352-2.302-2.352-3.958 
          0-2.254 1.695-4.16 3.916-4.494v-.002c0-2.853 2.37-5.165 5.275-5.165 1.776 0 3.407.871 4.38 
          2.294a5.071 5.071 0 0 1 .888 2.888z"/>
        <path 
          strokeLinecap="round" 
          strokeWidth="1.75" 
          d="M14.857 4.28L6.19 14.402"
        />
      </g>
    </svg>
  );
};
export default OfflineIconSingle;



// WEBPACK FOOTER //
// ./src/components/Iconoclast/OfflineIconSingle/index.js